import { isEmpty } from 'lodash';

import { Entitlements, PlanOfferDetails, Price, Promotions } from '../typings';

export function getPrice(price: Price, isBusiness: boolean): number {
  if (isBusiness) return price?.basePriceExcludingTax;
  return price?.basePrice;
}

interface AddPlanPromoDetails {
  dealText?: string;
  marketingTag?: string;
}

export function getMarketingTag(promotions: Promotions): string {
  return promotions?.find((promo) => promo?.productType === 'MARKETING')?.name;
}

export function getPromotionDeal(promotions: Promotions): Promotions[0] {
  return promotions?.find((promo) => promo?.productType === 'DEAL');
}

export function getSortedPromoCharacteristics(
  promotions: Promotions,
): Promotions {
  return (
    promotions
      ?.filter((promo) => promo?.productType === 'CHARACTERISTIC')
      .sort((a, b) => a.sortOrder - b.sortOrder) || []
  );
}

export function getSortedEntitlements(
  entitlements: Entitlements,
): Entitlements {
  return isEmpty(entitlements)
    ? null
    : [...entitlements].sort((a, b) => a.sortOrder - b.sortOrder);
}

export function hasMarketingTag(productOffers: PlanOfferDetails): boolean {
  return productOffers.some((offer) => getMarketingTag(offer.promotions));
}

export function getTrackingPromoDetails(
  promotions: Promotions,
): AddPlanPromoDetails {
  return {
    dealText: getPromotionDeal(promotions)?.longDescription,
    marketingTag: getMarketingTag(promotions),
  };
}
